module.exports = __webpack_public_path__ + "img/7. GMF Service_2.b285f08b.jpg";